<template>
  <div ref="reactMount"></div>
</template>

<script>
import { createRoot } from 'react-dom/client';
import { createElement } from 'react';
import isEqual from 'lodash/isEqual';
import cloneDeep from 'lodash/cloneDeep';

export default {
  name: 'Vue2React',

  props: {
    component: {
      type: [Object, Function],
      required: true,
    },
    props: {
      type: Object,
      default: () => ({}),
    },
  },

  data() {
    return {
      // For tracking previous props to detect changes
      internalProps: null,
      reactRoot: null,
    };
  },

  watch: {
    // Deep watching the props object to catch nested changes
    props: {
      handler(newProps) {
        // Avoid unnecessary re-renders by comparing deeply
        if (!isEqual(newProps, this.internalProps)) {
          // Create a deep clone to ensure React gets a fresh reference
          // This is critical for nested mutable objects from Vue
          this.internalProps = cloneDeep(newProps);
          this.renderReact();
        }
      },
      immediate: true,
      deep: true,
    },
    component() {
      this.renderReact();
    },
  },

  mounted() {
    this.renderReact();
  },

  beforeDestroy() {
    if (this.reactRoot) {
      this.reactRoot.unmount();
    }
  },

  methods: {
    renderReact() {
      if (!this.$refs.reactMount || !this.component) {
        return;
      }

      // We pass a fresh copy of the props to React
      // This ensures React sees it as a new object reference when Vue
      // mutates nested properties directly
      const reactProps = this.internalProps ? { ...this.internalProps } : cloneDeep(this.props);

      const element = createElement(this.component, reactProps);
      this.reactRoot = this.reactRoot || createRoot(this.$refs.reactMount);
      this.reactRoot.render(element);
    },
  },
};
</script>
